<template>
  <v-footer
    height="auto"
    dark
  >
    <v-card
      width="100%"
      flat
      tile
      :color="$root.themeColor"
      class="text-xs-center"
    >
      <v-card-text class="white--text pt-0" />
      <v-divider />
      <v-card-text class="white--text pt-0">
        &copy;2019 — <strong>Drive With Me</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>